/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux';

import { convertToJson } from '../../../../Common/utils';
import { getCurrentHistoryDetails } from '../../../selectors';

const useHistoryTab = () => {
  const historyTab = useSelector(getCurrentHistoryDetails);
  const historyInfo = convertToJson(historyTab);

  return historyInfo;
};

export default useHistoryTab;
